import * as yup from 'yup'

export default yup.object().shape({
  proxies: yup.array().min(1, 'O campo Procurador(es) é requerido.')
})
